import produce from "immer";

const INITIAL_STATE = {
  conversationId: "",
  questionMain: {},
  active: false,
  pendingSurveyId: null,
};

export default function conversation(state = INITIAL_STATE, action) {
  switch (action.type) {
    case "@survey/INIT_SURVEY":
      return produce(state, (draft) => {
        draft.conversationId = action.payload.conversationId;
        draft.questionMain = action.payload.questionMain;
        draft.pendingSurveyId = action.payload.pendingSurveyId;
        draft.active = action.payload.active;
      });
    default:
      return state;
  }
}
